import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model, OnDestroy, output, type OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { KuiActionModule, KuiIconModule } from 'app/key-ui';
import { KuiLoaderModule } from 'app/key-ui/loader/loader.module';
import { SelectionItem } from 'app/shared/components/selection/selection.model';
import { Subject } from 'rxjs';
import { VideoType } from '../request.component';

@Component({
    selector: 'key-video-type',
    imports: [
        CommonModule,
        KuiActionModule,
        KuiIconModule,
        FormsModule,
        KuiLoaderModule
    ],
    templateUrl: './video-type.component.html',
    styleUrl: './video-type.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoTypeComponent implements OnInit, OnDestroy {

    private destroyed: Subject<void> = new Subject();

    asset = input.required<SelectionItem>();
    isActive = input(false);

    options = computed<{ name: string; value: VideoType; disabled: boolean }[]>(() => [
        {
            name: this.i18n.instant('MEDIA.VIDEO_REQUEST.MODAL.VIDEO'),
            value: VideoType.CLIP,
            disabled: false,
        },
        {
            name: this.i18n.instant('MEDIA.VIDEO_REQUEST.MODAL.LIVESTREAM'),
            value: VideoType.STREAM,
            disabled: !this.isActive(), // livestreaming should be disabled unless it's during a trip
        }
    ]);

    type = model<VideoType>();
    videoTypeSelected = output<VideoType>();

    constructor(public i18n: TranslateService) { }

    ngOnInit(): void { }

    ngOnDestroy(): void {
        this.destroyed.next();
    }

    isValid(): boolean {
        return this.type() !== undefined;
    }

    handleModelChange(event: VideoType) {
        this.type.set(event);
        this.videoTypeSelected.emit(event);
    }

}
